import { styled, applyClassName } from '@glitz/react';
import { Link } from '@avensia/excite';

export const linkDecorator = styled({
  color: 'inherit',
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'none',
    color: 'inherit',
  },
  ':visited': {
    color: 'inherit',
  },
});

export default styled(applyClassName(Link), linkDecorator);
